<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('qualitycheck_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-bug-check</v-icon>N°{{ item['id'] }} - {{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-qualitycheck-show">
      <v-row>
        <v-col md="3" v-if="item['product']">
          <ImageView :item="item['product']" filter="250x250" :edit="false" />
        </v-col>
      <v-col md="9">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>

            <tr>
              <td><strong>{{ $t('qualitycheck.qualitycheck.product') }}</strong></td>
              <td>
                {{ item['product'].name }}
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.qualitycheck.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('qualitycheck.qualitycheck.comment') }}</strong></td>
              <td>
                                    {{ item['comment'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('qualitycheck.qualitycheck.usertesting') }}</strong></td>
              <td>
                                <span v-if="item['userTesting']">{{ item['userTesting'].login }}</span>
              </td>


              <td><strong>{{ $t('qualitycheck.qualitycheck.success') }}</strong></td>
              <td>
                    <v-switch v-if="item['success']"
                      color="primary"
                      value
                      class="pa-0 ml-0"
                      dense
                      input-value="true"
                      disabled
                    ></v-switch>
                    <v-switch v-else
                      disabled
                      dense
                    ></v-switch>
              </td>


            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.qualitycheck.start') }}</strong></td>
              <td>
                {{ formatDate(item['start'], 'long') }}              </td>
              <td><strong>{{ $t('qualitycheck.qualitycheck.end') }}</strong></td>
              <td>
                {{ formatDate(item['end'], 'long') }}              </td>


            </tr>


          </tbody>
        </template>
      </v-simple-table>
      </v-col>
    </v-row>
      <template>
        <div class="qualitycheckvalue-list">
          <Toolbar />

          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12>
                <h1>{{$t('qualitycheck.qualitycheck.qualitycheckvalues')}}</h1>
              </v-flex>
              <v-flex lg12>

                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="itemsSubs"
        :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
                  @click:row="showHandlerSubEvent"
                >
                <template slot="item.qualityCheckTest" slot-scope="{ item }">
                  <span v-if="locale == 'fr' & item['qualityCheckTest'].namefr != ''">{{ item['qualityCheckTest'].namefr }}</span>
                  <span v-else>{{ item['qualityCheckTest'].name }}</span>
                </template>
                <template slot="item.updated" slot-scope="{ item }">
                  {{ formatDate(item['updated'], 'long') }}
                </template>
                <template slot="item.value.name" slot-scope="{ item }">
                  <span v-if="item['value'].successValue"  ><v-icon color="green">mdi-check-circle</v-icon> {{ item['value'].name }}</span>
                  <span v-else><v-icon color="red">mdi-close-circle</v-icon>{{ item['value'].name }}</span>
                </template>


                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ImageView from '../../components/ImageView.vue';
import i18n from '../../i18n.js';

const servicePrefix = 'QualityCheck';

export default {
  name: 'QualityCheckShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageView
  },
  data() {
    return {
      headers: [
        { text: this.$t('qualitycheck.test.test'), value: 'qualityCheckTest' },
        { text: this.$t('global.date'), value: 'updated' },
        { text: this.$t('qualitycheck.qualitycheck.qualitycheckvalue'), value: 'value.name' },
        { text: this.$t('qualitycheck.qualitycheck.comment'), value: 'comment' },
      ],
      filters: {
        'qualityCheck' : this.$route.params.id,
      },
      options: {
        itemsPerPage: -1
      },
      selected: []
    };
  },
  mixins: [ShowMixin,AccessMixin,ListMixin],
  computed: {
    locale() {
      return i18n.locale;
    },
    ...mapFields('qualitycheck', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('qualitycheck', ['find']),
    ...mapGetters('qualitycheckvalue', {
      itemsSubs: 'list'
    }),
    ...mapFields('qualitycheckvalue', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('qualitycheck', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('qualitycheckvalue', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'QualityCheckValue',value);
    }
  }
};
</script>
